<template>
  <div :class="sizes">
    <div class="product-skeleton-link">
      <!-- image wrapper -->
      <div class="home__eshop__wrapper__img_wrapper placeholder-glow">
        <!-- hlavní obrázek -->
        <span class="placeholder col-12 product-skeleton-img"></span>
      </div>

      <!-- info -->
      <div class="info_wrapper">
        <!-- barevné varianty -->
        <div
          class="my-row center home__eshop__wrapper__img_wrapper__subProducts__wrapper mb-2"
        >
          <div
            v-for="n in 4"
            :key="n"
            class="home__eshop__wrapper__img_wrapper__subProducts placeholder-glow"
          >
            <span class="placeholder product-skeleton-dot"></span>
          </div>
        </div>

        <!-- název -->
        <h4 class="placeholder-glow mb-2">
          <span class="placeholder col-10"></span>
        </h4>

        <!-- popis -->
        <span class="home__eshop__wrapper__name placeholder-glow">
          <span class="placeholder col-12 mb-2"></span>
          <span class="placeholder col-8"></span>
        </span>

        <!-- cena -->
        <div class="home__eshop__wrapper__price placeholder-glow">
          <span class="placeholder col-5"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductSkeleton",
  props: {
    sizes: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  justify-content: center;
  gap: 0.6rem;
}

.info_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.product-skeleton-link {
  height: 100%;
  display: block;
}

/* ===============================
   IMAGE WRAPPER
   =============================== */
.home__eshop__wrapper__img_wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0.8rem 0;
  overflow: hidden;
}

/* ===============================
   SKELETON IMAGE – 90 %
   =============================== */
.product-skeleton-img {
  display: block;
  width: 90%;
  aspect-ratio: 1 / 1;
  border-radius: 1.6rem; /* větší radius pro obrázek */
}

/* ===============================
   TITLE – 90 % + MENŠÍ RADIUS
   =============================== */
h4.placeholder-glow {
  width: 100%;
  display: flex;
  justify-content: center;
}

h4.placeholder-glow > .placeholder {
  width: 90% !important;
  border-radius: 1.2rem; /* ✅ jemný textový radius */
}

/* ===============================
   POPIS – MENŠÍ RADIUS
   =============================== */
.home__eshop__wrapper__name {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.home__eshop__wrapper__name .placeholder {
  width: 90%;
  border-radius: 1rem; /* ✅ ještě jemnější */
}

/* ===============================
   CENA – JEŠTĚ MENŠÍ RADIUS
   =============================== */
.home__eshop__wrapper__price {
  width: 100%;
  display: flex;
  justify-content: center;
}

.home__eshop__wrapper__price .placeholder {
  width: 60%;
  border-radius: 1rem; /* ✅ krátký text = menší radius */
}

/* ===============================
   BAREVNÉ TEČKY
   =============================== */
.product-skeleton-dot {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 1.2rem;
}
</style>
